import React from 'react';
import { TopToolbar, FilterButton } from 'react-admin';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { CustomExportButton } from '../CustomExportButton';
import { MAX_PER_PAGE } from '../../constants/define';

interface OrderListActionsProps {
  createExporter: (type: 'order' | 'detail') => (records: any[]) => Promise<void>;
}

/**
 * 注文一覧画面のツールバーアクション
 *
 * 【外部コンポーネント化の理由】
 * 以前は OrderList 内でインライン定義されていましたが、それにより検索入力（フィルタ変更）のたびに
 * コンポーネントが新しいものとして認識され、アンマウント・再マウントが発生していました。
 * これが「入力時に表示がおかしくなる（チラつく）」現象の原因となっていたため、
 * 描画パフォーマンスの最適化と Admin/Client/Partner 間のロジック共通化を目的として外部化されました。
 */
const OrderListActions = ({ createExporter }: OrderListActionsProps) => {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('md'));

  // 'md'未満の画面サイズで適用する共通スタイル
  const smallButtonSx = {
    flexDirection: 'column',
    padding: '6px 8px',
    minWidth: 'auto',
    '& .MuiButton-startIcon': {
      margin: 0,
    },
  };

  return (
    <TopToolbar sx={{ flex: { sm: '0 0 0%' } }}>
      <FilterButton />
      {isSmall ? (
        <>
          <CustomExportButton
            label="注文ID別"
            exporter={createExporter('order')}
            sx={smallButtonSx}
            maxResults={MAX_PER_PAGE}
          />
          <CustomExportButton
            label="注文詳細"
            exporter={createExporter('detail')}
            sx={smallButtonSx}
            maxResults={MAX_PER_PAGE}
          />
        </>
      ) : (
        <>
          <CustomExportButton
            label="注文ID別CSVダウンロード"
            exporter={createExporter('order')}
            maxResults={MAX_PER_PAGE}
          />
          <CustomExportButton
            label="注文詳細CSVダウンロード"
            exporter={createExporter('detail')}
            maxResults={MAX_PER_PAGE}
          />
        </>
      )}
    </TopToolbar>
  );
};

export default OrderListActions;
